import * as React from 'react';
import { Editor, EditorChangeEvent, EditorTools } from '@progress/kendo-react-editor'

const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
} = EditorTools 

const KendoEditor = ({
  tools,
  content,
  contentStyle,
  onChange,
  onBlur,
  value,
  dir = 'ltr',
}: {
  tools: any[]
  content: string
  contentStyle: React.CSSProperties
  onChange: (event: EditorChangeEvent) => void
  onBlur?: () => void
  value: string
  dir?: string
}) => {
  return (
    <Editor
      dir={dir}
      tools={tools}
      contentStyle={contentStyle}
      defaultContent={content}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      defaultEditMode="div"
    />
  )
}

export default KendoEditor;
